import { get, postHadle, getHandle } from "@/utils/request";

// 获取是否启用验证码
export function getCaptchaEnable() {
  return get("/prod-api/api/captcha/getEnable");
}

// 获取验证图片  以及token
export function reqGet(data) {
  return postHadle("/prod-api/api/captcha/get", data);
}

// 滑动或者点选验证
export function getCodeImg() {
  return getHandle("/default/captchaImage");
}

export function login(data) {
  return postHadle("/default/login", data);
}
export function getInfo() {
  return getHandle("/default/getInfo");
}

export function loginToSso(queryParam) {
  console.log("login.js queryParam = " + queryParam);
  console.log(queryParam);
  return postHadle("/default/loginSso", queryParam);
}
